<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle :lang="lang.Middle"></Middle>
            <Right v-show="isVisibleRight" :lang="lang.Right" class="RequestDetailsRight"></Right>

 </div>
</template>

<script>
import Left from '@/components/RequestManager/Views/RequestDetails/Left/Left'
import Middle from '@/components/RequestManager/Views/RequestDetails/Middle/Middle'
import Right from '@/components/RequestManager/Views/RequestDetails/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'RequestDetails',
  components:{
    Left,
    Middle,
    Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    lang: Object
  },
}
</script>


<style scoped>
  .RequestDetailsRight{
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestDetails.vue